<template>
  <div>
    <table class="modal__control_file-list-control">
      <tr>
        <td>
          {{ this.filesTotal }}
          <span v-if="this.filesTotal === 1">Dokument</span>
          <span v-if="this.filesTotal > 1">Dokumente</span>
          <span v-if="this.new > 0">({{ this.new }} neu)</span>
        </td>
        <!-- <td v-show="isPaginationVisible()">
                    <table class="minipagination minipagination--right">
                        <tr>
                            <td class="minipagination_page">
                                {{ this.displayNumber }}/{{ this.maxPage }}
                            </td>
                            <td class="minipagination_control minipagination_control--next">
                                <button :class="{'modal__control-flpagi modal__control-flpagi--next':true, 'modal__control-flpagi--nextdisabled':!isNextVisible()}" :disabled="!isNextVisible()" @click="nextAction()"></button>
                            </td>
                            <td class="minipagination_control minipagination_control--prev">
                                <button :class="{'modal__control-flpagi modal__control-flpagi--prev':true, 'modal__control-flpagi--prevdisabled':!isPrevVisible()}" :disabled="!isPrevVisible()" @click="prevAction()"></button>
                            </td>
                        </tr>
                    </table>
                </td> -->
      </tr>
    </table>
    <div class="scroll">
      <ul class="modal__control_file-list">
        <li
          v-for="(file, key) in paginatedFileList"
          class="modal__control_file-listitem"
        >
          {{ file.name
          }}<span
            class="modal__control_file-itemremover"
            @click="removeFile(key)"
          ></span>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: "ControlFileList",
  props: {
    new: {
      type: Number,
      default: 0
    },
    files: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      pageNumber: 0,
      displayNumber: 1,
      size: 5
    };
  },
  methods: {
    nextAction() {
      this.pageNumber++;
      this.displayNumber++;
    },
    prevAction() {
      this.pageNumber--;
      this.displayNumber--;
    },
    removeFile(key) {
      this.$emit("remove-file", key);
    },
    isPaginationVisible() {
      return this.maxPage > 1;
    },
    isPrevVisible() {
      return this.maxPage > 1 && this.pageNumber > 0;
    },
    isNextVisible() {
      return this.maxPage > 1 && this.pageNumber < this.maxPage - 1;
    }
  },
  computed: {
    paginatedFileList() {
      // const start = this.pageNumber * this.size,
      //         end = start + this.size;
      // return this.files.slice(start, end);
      return this.files;
    },
    filesTotal() {
      return this.files.length;
    },
    maxPage() {
      return Math.ceil(this.filesTotal / this.size);
    }
  }
};
</script>
